/**
 * @fileoverview Area-related route definitions. Detail routes for individual
 * areas remain in notesRoutes.tsx; this file adds the hub listing page.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { createRoutes } from '../utils/routeHelpers';

const AreasHubPage = lazy(() => import('../../features/areas/pages/AreasHubPage'));

export const areasRoutes: RouteObject[] = createRoutes([
  { path: 'areas', Component: AreasHubPage },
]);
